import React, { useEffect, useState } from "react";
import Select from "react-select";

export type Option = {
    value: string;
    label: string;
};

export interface SelectProps {
    options: Option[];
    defaultValue?: Option | Option[];
    className?: string;
    styles?: any;
    placeholder?: string;
    onChange?: (option: Option | Option[] | null) => void;
    value?: Option | Option[] | null;
    isMulti?: boolean;
    isDisabled?: boolean;
}

const CommonSelect: React.FC<SelectProps> = ({ options, defaultValue, className, placeholder, onChange, value, isMulti = false, isDisabled = false }) => {
    const [selectedOption, setSelectedOption] = useState<Option | Option[] | undefined>(defaultValue);

    const customStyles = {
        control: (base: any) => ({
            ...base,
            border: "1px solid #E7E8EB",
            borderRadius: "0.375rem",
            minHeight: "44px",
            boxShadow: "none",
            "&:hover": {
                borderColor: "#2E37A4"
            }
        }),
        option: (base: any, state: any) => ({
            ...base,
            color: state.isFocused ? "#fff" : "#6C7688",
            backgroundColor: state.isSelected ? "#2e37a4" : state.isFocused ? "#2e37a4" : "white",
            cursor: "pointer",
        }),
    };

    const handleChange = (option: any) => {
        setSelectedOption(option || undefined);
        if (onChange) onChange(option);
    };

    useEffect(() => {
        if (value !== undefined) {
            setSelectedOption(value || undefined);
        } else if (defaultValue) {
            setSelectedOption(defaultValue);
        }
    }, [defaultValue, value]);

    return (
        <Select
            classNamePrefix="react-select"
            className={className}
            styles={customStyles}
            options={options}
            value={selectedOption}
            onChange={handleChange}
            placeholder={placeholder || "Select"}
            isMulti={isMulti}
            isDisabled={isDisabled}
        />
    );
};

export default CommonSelect;
